import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


export default {

payMoney: ( params ) => AjaxPlugin.$http.get( `/wxpay/createOrder?openId=${ params.openId }&plateNumber=${ params.plateNumber }&money=${ params.money }` ),

authorization: ( data ) => AjaxPlugin.$http.post( `/api/pay/wx/user/getWxOpenIdInfo`, data ),

temppay: ( data ) => AjaxPlugin.$http.post( `/api/parklot/order/orderpay/temppay`, data ),

temporarycarcharge: ( data ) => AjaxPlugin.$http.post( `/api/parklot/wx/temporarycarcharge/querycharge`, data ),

noPlatenumPay: ( data ) => AjaxPlugin.$http.post( `/api/parklot/order/orderpay/noplatenumpay`, data ),

aliUserInfo: ( data ) => AjaxPlugin.$http.post( `https://tcc.grg.cn/grgApi/user/userInfo/getAliUserInfo`, data ),

queryMainParklot: ( data ) => AjaxPlugin.$http.get( `/api/parklot/wx/parklot/queryMainParklot`, data )
};



// WEBPACK FOOTER //
// ./src/api/pay.js